import React, { Component } from "react";
import Hero from "../components/Hero/Hero";
import "../App.css";
export default class Home extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <>
        <Hero />
      </>
    );
  }
}
